import { observer } from 'mobx-react';
import { action } from 'mobx';
import React from 'react';

import TableToolbar from '../../shared/tableToolbar';
import DoctorClinicStore from './DoctorClinicStore';
import customFetch from '../../../utils/customFetch';

const Labels = [
  { text: 'Selected Clinics', value: 'selected' },
  { text: 'All Clinics', value: 'all' },
];

@observer
class ModalDoctorToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clinics: DoctorClinicStore.clinics,
    };
  }

  componentDidMount() {
    if (!DoctorClinicStore.loading && DoctorClinicStore.clinics) {
      this.setState({
        clinics: DoctorClinicStore.clinics,
      });
    }
  }
  renderFilterOptions = () => {
    return Labels.map(opt => ({
      text: opt.text,
      value: opt.value,
    }));
  };

  renderFilterText = value => {
    let labels = Labels.filter(opt => opt.value === value).map(opt => opt.text);
    return labels[0];
  };

  fetchDoctorByList = () => {
    customFetch('/Clinic/GetClinicByIdList', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify(this.state.clinics.map(i => i)),
    }).then(
      action(data =>
        DoctorClinicStore.setFieldsValue({
          data,
          loading: false,
          totalPage: data.sumPage || DoctorClinicStore.totalPage,
          curPage: 1,
        }),
      ),
    );
  };

  handleFilter = (_, { value }) => {
    DoctorClinicStore.setFieldsValue({
      loading: true,
      filter: value,
    });
    if (value === `all`) {
      DoctorClinicStore.refetch({ curPage: 1 }, true);
    } else {
      this.fetchDoctorByList();
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    DoctorClinicStore.refetch({ curPage: 1, filter: `All` }, true);
  };

  handleReset = e => {
    e.preventDefault();
    if (this.state.doctors === 0) {
      DoctorClinicStore.resetStore();
      DoctorClinicStore.refetch({}, true);
    } else {
      this.fetchDoctorByList();
      DoctorClinicStore.setFieldsValue({ filter: `selected`, keyword: `` });
    }
  };

  render() {
    const { keyword, loading, filter } = DoctorClinicStore;
    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Filter
            value={this.renderFilterText(filter)}
            options={this.renderFilterOptions()}
            onChange={this.handleFilter}
          />
          <TableToolbar.Input
            placeholder={'Search'}
            value={keyword}
            onChange={DoctorClinicStore.handleSearchChange}
            disabled={loading}
          />
          <TableToolbar.HighLightButton className="blue" disabled={loading}>
            Search
          </TableToolbar.HighLightButton>
        </TableToolbar.Left>
        <TableToolbar.Right>
          <TableToolbar.HighLightButton
            className="negative"
            disabled={loading}
            onClick={this.handleReset}
            style={{ marginLeft: '5px' }}
          >
            Clear
          </TableToolbar.HighLightButton>
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default ModalDoctorToolbar;
